import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-hot-toast'

import { AppButton } from '@/components/AppButton'
import { SumsubWebSDKModal } from '@/components'
import { useGetKycAccessToken } from '@/domain'
import { useCheckTransactionEligibility } from '@/hooks/useCheckTransactionEligibility/useCheckTransactionEligibility'
import { useAppAnalytics } from '@/services/analytics'
import { useLocation } from 'react-router-dom'

export const OpenSumsubSDKButton = () => {
  const { t } = useTranslation()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const { trackEvent, events } = useAppAnalytics()
  const location = useLocation()

  const { data: kycSdkAccessToken, isPending: isPendingKycSdkAccessToken } =
    useGetKycAccessToken()

  const { checkTransactionEligibility } = useCheckTransactionEligibility({
    feature: 'kyc',
  })

  const launchSumsubSDK = useCallback(async () => {
    const isEligible = await checkTransactionEligibility()

    if (!isEligible) {
      return
    }

    trackEvent(events.KYC_STARTED, {
      entry_point: location.pathname.includes('setup') ? 'onboarding' : 'home',
    })

    if (!kycSdkAccessToken?.token) {
      toast.error(t('api:errors.somethingWrong'))
      return
    }

    // Open fullscreen modal with Sumsub SDK
    setIsModalOpen(true)
  }, [kycSdkAccessToken?.token, checkTransactionEligibility, t])

  const handleCloseModal = useCallback(() => {
    setIsModalOpen(false)
  }, [])

  return (
    <>
      <AppButton
        label={t('form:actions.continue')}
        onPress={launchSumsubSDK}
        isLoading={isPendingKycSdkAccessToken}
      />

      {/* Sumsub SDK Modal - fullscreen overlay */}
      {kycSdkAccessToken?.token && (
        <SumsubWebSDKModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          accessToken={kycSdkAccessToken.token}
        />
      )}
    </>
  )
}
